__turbopack_context__.v({
  "passport_feature_table__checkmark": "fcOjja_passport_feature_table__checkmark",
  "passport_feature_table__dash": "fcOjja_passport_feature_table__dash",
  "passport_feature_table__feature": "fcOjja_passport_feature_table__feature",
  "passport_feature_table__header_description_passport": "fcOjja_passport_feature_table__header_description_passport",
  "passport_feature_table__header_description_pbs": "fcOjja_passport_feature_table__header_description_pbs",
  "passport_feature_table__one_checkmark": "fcOjja_passport_feature_table__one_checkmark",
  "passport_feature_table__station_logo": "fcOjja_passport_feature_table__station_logo",
  "passport_feature_table__station_passport_title": "fcOjja_passport_feature_table__station_passport_title",
  "passport_feature_table__title": "fcOjja_passport_feature_table__title",
  "passport_feature_table__two_checkmarks": "fcOjja_passport_feature_table__two_checkmarks",
  "passport_feature_table__wrapper": "fcOjja_passport_feature_table__wrapper",
  "passport_feature_table_condensed": "fcOjja_passport_feature_table_condensed",
  "passport_feature_table_condensed__feature": "fcOjja_passport_feature_table_condensed__feature",
  "passport_feature_table_condensed__header": "fcOjja_passport_feature_table_condensed__header",
  "passport_feature_table_condensed__header_item": "fcOjja_passport_feature_table_condensed__header_item",
  "passport_feature_table_donate_button": "fcOjja_passport_feature_table_donate_button",
  "passport_feature_table_full": "fcOjja_passport_feature_table_full",
});
